import {BaseIdModel} from '../models/base-id.model';

export class ApiMessage {
  constructor(value: Partial<ApiMessage>) {
    Object.assign(this, value);
  }
  ShowMore: boolean = false;
  Code: number;
  Messages: string[];
  Model: any;
}

export class ApiResponse<T extends BaseIdModel | BaseIdModel[] | any> {
  constructor(value: Partial<ApiResponse<T>>) {
    Object.assign(this, value);
  }

  Errors: ApiMessage[] = [];
  Informations: ApiMessage[] = [];
  IsValid: boolean;
  Warnings: ApiMessage[] = [];
  data: T;
  status: number;
  Timestamp?: Date;

  isValid(level: 'Error' | 'Warning' | 'Info' = "Error"): boolean {
    if (!this.IsValid) {
      return false;
    }
    if (level === "Error" && this.Errors.length === 0) {
      return true;
    }
    if (level === "Warning" && this.Errors.length === 0 && this.Warnings.length === 0) {
      return true;
    }
    if (level === "Info" && this.Errors.length === 0 && this.Warnings.length === 0 && this.Informations.length === 0) {
      return true;
    }
  }
}
